module.exports = __webpack_public_path__ + "static/media/jakob_2025.19466c74.jpg";